import React, { useState, createContext, useContext } from 'react';
type Language = 'en' | 'zu' | 'af' | 'st' | 'xh';
interface Translations {
  heroEyebrow: string;
  heroTitle: string;
  heroSub: string;
  waitlistBtn: string;
  howItWorksBtn: string;
  navHowItWorks: string;
  problemTitle: string;
}
const translations: Record<Language, Translations> = {
  en: {
    heroEyebrow: 'Built for South African families',
    heroTitle: 'Pay your store accounts. No app. No data. Just SMS.',
    heroSub: 'Masube Settle lets you settle Truworths, Edgars, Mr Price and more — straight from any phone. Even a Nokia.',
    waitlistBtn: 'Join the waitlist',
    howItWorksBtn: 'See how it works',
    navHowItWorks: 'How it works',
    problemTitle: 'Tired of standing in queues just to pay an account?'
  },
  zu: {
    heroEyebrow: 'Yakhelwe imindeni yaseNingizimu Afrika',
    heroTitle: 'Khokhela ama-akhawunti akho esitolo. Ayikho i-app. Ayikho i-data. I-SMS kuphela.',
    heroSub: 'I-Masube Settle ikuvumela ukuthi ukhokhele i-Truworths, Edgars, Mr Price nokunye — ngqo kunoma iyiphi ifoni. Ngisho ne-Nokia.',
    waitlistBtn: 'Joyina uhlu lokulinda',
    howItWorksBtn: 'Bona ukuthi kusebenza kanjani',
    navHowItWorks: 'Indlela okusebenza ngayo',
    problemTitle: 'Ukhathele ukuma kolayini ukuze ukhokhe i-akhawunti?'
  },
  af: {
    heroEyebrow: 'Gebou vir Suid-Afrikaanse gesinne',
    heroTitle: 'Betaal jou winkelrekeninge. Geen app. Geen data. Net SMS.',
    heroSub: "Masube Settle laat jou Truworths, Edgars, Mr Price en meer betaal — direk vanaf enige foon. Selfs 'n Nokia.",
    waitlistBtn: 'Sluit aan by die waglys',
    howItWorksBtn: 'Kyk hoe dit werk',
    navHowItWorks: 'Hoe dit werk',
    problemTitle: "Moeg om in rye te staan net om 'n rekening te betaal?"
  },
  st: {
    heroEyebrow: 'E ahetswe malapa a Afrika Borwa',
    heroTitle: 'Lefa diakhaonte tsa hao tsa mabenkele. Ha ho app. Ha ho data. Ke SMS feela.',
    heroSub: 'Masube Settle e o dumella ho lefa Truworths, Edgars, Mr Price le tse ding — ka kotloloho fonong efe kapa efe. Esita le Nokia.',
    waitlistBtn: 'Kena lenaneng la ba emetseng',
    howItWorksBtn: 'Bona hore na e sebetsa jwang',
    navHowItWorks: 'Kamoo e sebetsang kateng',
    problemTitle: 'O kgathetse ke ho ema meleng ho lefa akhaonte?'
  },
  xh: {
    heroEyebrow: 'Yakhelwe iintsapho zaseMzantsi Afrika',
    heroTitle: 'Hlawula ii-akhawunti zakho zevenkile. Akukho app. Akukho data. Yi-SMS kuphela.',
    heroSub: 'I-Masube Settle ikuvumela ukuba uhlawule i-Truworths, Edgars, Mr Price kunye nezinye — ngqo kuyo nayiphi na ifowuni. Nokuba yi-Nokia.',
    waitlistBtn: 'Joyina uluhlu lwabalindileyo',
    howItWorksBtn: 'Bona indlela esebenza ngayo',
    navHowItWorks: 'Indlela esebenza ngayo',
    problemTitle: 'Udiniwe kukulinda emigceni ukuze uhlawule i-akhawunti?'
  }
};
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t: translations[language]
  }} data-id="element-249">
      
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}